<script setup lang="ts">
  import type { FilterableSliderStoryblok } from '@/storyblok/component-types-sb'
  import { cva } from 'class-variance-authority'

  const props = defineProps<{
    blok: FilterableSliderStoryblok
  }>()

  const selectedFilter = ref<string>(String(props.blok.sliderItemsCategories?.[0] ?? ''))

  const activeDescription = computed(() => {
    const descriptionItem = props.blok.descriptionsByFilter?.find(
      (item) => String(item.category) === selectedFilter.value
    )

    return descriptionItem?.description ? descriptionItem.description[0] : null
  })

  const filteredSlider = computed(() => {
    const sliderBlok = props.blok.slider?.[0]

    if (!sliderBlok) {
      return null
    }

    const cards = sliderBlok.cards ?? []

    return {
      ...sliderBlok,
      cards: cards.filter((card: any) =>
        card?.categories?.some((category: string | number) => String(category) === selectedFilter.value)
      )
    }
  })

  const wrapperCva = computed(() =>
    cva('sm:-mb-4', {
      variants: {
        withoutTopMargin: {
          true: 'sm:-mt-8',
          false: ''
        }
      }
    })({
      withoutTopMargin: props.blok.withoutTopMargin
    })
  )
</script>

<template>
  <div :class="wrapperCva">
    <div class="lg:mx-auto lg:w-10/12 lg:gap-x-16 lg:pb-6 lg:pt-10">
      <div class="flex flex-col items-center lg:flex-row lg:items-center lg:justify-between">
        <div class="mx-auto -mb-4 sm:w-2/3 sm:text-center md:text-left lg:mx-0 lg:w-1/2">
          <h2 class="text-h2 md:mb-6">{{ blok.title }}</h2>
          <div v-if="activeDescription">
            <StoryblokComponent :blok="activeDescription" />
          </div>
        </div>

        <div class="flex w-full min-w-0 sm:w-4/5 sm:justify-center lg:w-1/2">
          <LazyFilterableCardsFilterButtons
            v-if="blok.sliderItemsCategories"
            v-model:selected="selectedFilter"
            :filters="blok.sliderItemsCategories"
            :show-all-option="false"
            button-style="secondary"
            layout-mode="wrap"
          />
        </div>
      </div>
    </div>

    <CardsSlider
      v-if="filteredSlider"
      :key="`${filteredSlider._uid}-${selectedFilter}`"
      :blok="filteredSlider"
      :loop="true"
    />
  </div>
</template>
